var _path, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5063 16.834L4.73358 19.7655C4.49092 19.8887 4.18893 19.7874 4.05906 19.5393C3.9292 19.2911 4.02063 18.9901 4.26329 18.8669L10.1362 15.8845C10.2547 15.8243 10.3874 15.8177 10.5073 15.8555C10.6268 15.8181 10.759 15.8249 10.8771 15.8849L16.75 18.8672C16.9927 18.9905 17.0841 19.2915 16.9543 19.5397C16.8244 19.7878 16.5224 19.8891 16.2797 19.7659L10.5063 16.834Z",
    fill: "#004BA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.5H20.5V14C20.5 14.8284 19.8284 15.5 19 15.5H3C2.17157 15.5 1.5 14.8284 1.5 14V2.5Z",
    stroke: "#004BA5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 7.25,
    width: 9.5,
    height: 0.5,
    rx: 0.25,
    fill: "#004BA5",
    stroke: "#004BA5",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 9.25,
    width: 9.5,
    height: 0.5,
    rx: 0.25,
    fill: "#004BA5",
    stroke: "#004BA5",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 11.25,
    width: 9.5,
    height: 0.5,
    rx: 0.25,
    fill: "#004BA5",
    stroke: "#004BA5",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 2.38083,
    rx: 1.19041,
    fill: "white",
    stroke: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.56d53ed8b25327ad652d7eaf3d864b95.svg";
export { ForwardRef as ReactComponent };